import { Component, OnInit, Input, Inject, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { EFormMode } from '@common/enums/common.enum';

import { FsItem, Tag, BitfFormItemConfig, FsStore } from '@models';
import { FsService, LoaderService, UiRoleManagerService } from '@services';
import { IBitfApiResponse, IBitfCloseEvent } from '@interfaces';
import { EBitfCloseEventStatus, ERoleActions } from '@enums';

@Component({
  selector: 'prada-fs-create-update-files',
  templateUrl: './fs-create-update-files.component.html',
  styleUrls: ['./fs-create-update-files.component.scss'],
})
export class FsCreateUpdateFilesComponent implements OnInit {
  EFormMode = EFormMode;
  form: FormGroup;
  formItemsConfig: BitfFormItemConfig;
  files: FsItem[] = [];
  isUploading = false;

  constructor(
    public dialogRef: MatDialogRef<FsCreateUpdateFilesComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { mode: EFormMode; fsItem: FsItem; fsStore: FsStore },
    private fsService: FsService,
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private uiRoleManagerService: UiRoleManagerService
  ) {}

  ngOnInit() {
    this.initForm();

    if (this.uiRoleManagerService.canI(ERoleActions.SHOW_TAG, { fsStore: this.dialogData.fsStore })) {
      this.loaderService.show();
      this.fsService
        .useFs(this.dialogData.fsStore)
        .getFormItemConfig()
        .subscribe((response: IBitfApiResponse<BitfFormItemConfig>) => {
          this.formItemsConfig = response.content;
          this.patchForm();
        });
    }
  }

  onSubmit() {
    if (this.dialogData && this.dialogData.mode === EFormMode.UPDATE) {
      this.dialogRef.close({
        status: EBitfCloseEventStatus.OK,
        data: new FsItem({ ...this.dialogData.fsItem, ...this.form.value }),
      } as IBitfCloseEvent<FsItem>);
    }
  }

  close() {
    this.dialogRef.close({
      status: EBitfCloseEventStatus.OK,
      data: this.files,
    } as IBitfCloseEvent<FsItem[]>);
  }

  isUploadingEvent(event: boolean) {
    this.isUploading = event;
  }

  onFilesUploaded(files: FsItem[]) {
    const filesWithErrors = files.some(file => file === undefined);
    this.files = files.filter(file => !!file);
    if (filesWithErrors) {
      return;
    }
    this.close();
  }

  private initForm() {
    this.form = this.formBuilder.group({
      tags: null,
    });
  }

  private patchForm() {
    if (this.dialogData.fsItem) {
      this.form.patchValue(this.dialogData.fsItem);
    }
  }
}
